import { css } from 'styled-components';
import { contrastTextOn, resolvePalette } from '@blade/ui-theme';
import { BUTTON_HEIGHT_MAP } from './constants';
export const buttonShapeCss = ({ $size, $fullWidth, $onlyIcon, }) => {
    const height = `${BUTTON_HEIGHT_MAP[$size]}px`;
    const width = (() => {
        if ($fullWidth) {
            return '100%';
        }
        // Icons are square
        return $onlyIcon ? height : undefined;
    })();
    if ($size === 'l') {
        return css `
      height: ${height};
      width: ${width};
      gap: 8px;
    `;
    }
    return css `
    height: ${height};
    width: ${width};
    gap: 5px;
  `;
};
export const solidCss = ({ theme, disabled, $color, $loading, }) => {
    if (disabled) {
        return css `
      background: var(--backgroundA-3);
      color: var(--backgroundA-7);
    `;
    }
    if ($color === 'background') {
        const base = css `
      background: var(--background-12);
      color: var(--background-1);
    `;
        if ($loading) {
            return base;
        }
        // background color is exception
        return css `
      ${base}
      &:hover {
        background: var(--background-11);
      }
      &:active {
        background: var(--background-10);
      }
    `;
    }
    const palette = resolvePalette(theme, $color);
    // The text the fill needs, not always white: on the kol.trade yellow white
    // text cannot be read.
    const base = css `
    background: ${palette[9]};
    color: ${contrastTextOn(palette[9])};
  `;
    if ($loading) {
        return base;
    }
    return css `
    ${base}
    &:hover {
      background: ${palette[10]};
    }
  `;
};
export const gradientCss = ({ disabled, $gradient, $loading, }) => {
    if (disabled) {
        return css `
      background: linear-gradient(
        90deg,
        rgba(239, 230, 238, 0.2) 0%,
        rgba(125, 125, 125, 0.2) 50%,
        rgba(52, 52, 52, 0.2) 100%
      );
      color: var(--backgroundA-7);
    `;
    }
    const base = css `
    background: ${$gradient};
    color: var(--background-12);
  `;
    if ($loading) {
        return base;
    }
    return css `
    ${base}
    &:hover {
      color: var(--background-11);
    }
  `;
};
export const secondaryCss = ({ theme, disabled, $color, $loading, }) => {
    if (disabled) {
        return css `
      border: 1px solid var(--backgroundA-2);
      color: var(--backgroundA-6);
    `;
    }
    if ($color === 'background') {
        // background color is exception
        const base = css `
      border: 1px solid var(--backgroundA-4);
      color: var(--background-11);
    `;
        if ($loading) {
            return base;
        }
        return css `
      ${base}
      &:hover {
        color: var(--background-12);
      }
    `;
    }
    // TODO: Wait for designs
    const palette = resolvePalette(theme, $color);
    const base = css `
    border: 1px solid ${palette[4]};
    color: ${palette[12]};
  `;
    if ($loading) {
        return base;
    }
    return css `
    ${base}
    &:hover {
      color: ${palette[11]};
    }
  `;
};
export const softCss = ({ theme, disabled, $color, $loading, }) => {
    if (disabled) {
        return css `
      background: var(--backgroundA-3);
      color: var(--backgroundA-7);
    `;
    }
    // background color is exception
    if ($color === 'background') {
        const base = css `
      background: var(--backgroundA-4);
      color: var(--background-11);
    `;
        if ($loading) {
            return base;
        }
        return css `
      ${base}
      &:hover {
        background: var(--backgroundA-6);
        color: var(--background-12);
      }
      &:active {
        background: var(--backgroundA-5);
        color: var(--background-12);
      }
    `;
    }
    // TODO: Wait for designs
    const palette = resolvePalette(theme, $color);
    const base = css `
    border: 1px solid ${palette[4]};
    color: ${palette[12]};
  `;
    if ($loading) {
        return base;
    }
    return css `
    ${base}
    &:hover {
      border: 1px solid ${palette[6]};
    }
  `;
};
export const ghostCss = ({ theme, disabled, $loading, $color, }) => {
    if (disabled) {
        return css `
      color: var(--background-7);
    `;
    }
    if ($color === 'background') {
        const base = css `
      color: var(--background-11);
    `;
        if ($loading) {
            return base;
        }
        return css `
      ${base}
      &:hover {
        color: var(--background-12);
        background: var(--backgroundA-3);
      }
      &:active {
        background: var(--backgroundA-4);
      }
    `;
    }
    const palette = resolvePalette(theme, $color);
    const base = css `
    color: ${palette[9]};
  `;
    if ($loading) {
        return base;
    }
    return css `
    ${base}
    &:hover {
      background: var(--backgroundA-3);
    }
    &:active {
      background: var(--backgroundA-4);
    }
  `;
};
export const glass2Css = ({ $color }) => {
    return css `
    border: 1px solid ${`var(--${$color}-5)`};
    background: ${`var(--${$color}-2)`};
    color: ${`var(--${$color}-10)`};
    &:disabled:not([data-busy='true']) {
      background: transparent;
      border-color: ${`var(--background-4)`};
      color: ${`var(--background-7)`};
    }
    &:not(:disabled):hover {
      background: ${`var(--${$color}-4)`};
      color: ${`var(--${$color}-11)`};
    }
  `;
};
export const buttonVariablesCss = css `
  :root {
    --button-radius-rounded: 8px;
    --button-radius-full: 64px;
  }
`;
//# sourceMappingURL=button-styles.js.map